function PmsGeneralSettingsService(hUser) {
    const self = this;
    const [getPmsGeneralSettings] = cacheService.cache(PmsAPI.getPMSGeneralSettings);

    const [getManagementBrandId] = cacheService.cache(PmsAPI.getPMSManagementBrandId);

    self.getPmsGeneralSettings = getPmsGeneralSettings;

    self.getManagementBrandId = getManagementBrandId;

    self.checkManagementLevel = async (brandType) => {
        const pmsGeneralSettings = await self.getPmsGeneralSettings(hUser.getEntryMode().brand_id);
        const managementLevel =  pmsGeneralSettings.management_level;
        let canAccessSameLevel = false;
        let canAccessSameAndBelowLevel = false;

        if (managementLevel === 'enterprise' && managementLevel === brandType) {
            canAccessSameLevel = true;
            canAccessSameAndBelowLevel = true;
        }

        if (managementLevel.includes('GP')) {
            canAccessSameLevel = brandType === managementLevel;
            canAccessSameAndBelowLevel = canAccessSameAndBelowLevel = brandType === 'enterprise'? true: brandType <= managementLevel;
        }

        return {canAccessSameLevel, canAccessSameAndBelowLevel};
    };
}
angular
    .module("harriApp")
    .service("pmsGeneralSettingsService", PmsGeneralSettingsService);
PmsGeneralSettingsService.$inject = ['hUser'];